import { Container, Grid } from '@mui/material'
import { TitleHeader } from 'components/shop-reception/mobile/Common/TitleHeader'
import { useFormik } from 'formik'
import { useMemo, useState } from 'react'
import { getInitialValues, getValidationSchema } from './helpers'
import { Button, Input } from '@fullscreendigital/carrefour-dex-fe'
import { getReturoId, validateScanCode } from 'components/shop-reception/mobile/helpers'
import { useNotification } from 'hooks'
import { toReportPayload } from './serializers'
import { useMutation } from 'react-query'
import { formatErrorMessage } from 'utils/formatting'
import { makeCorePostRequest } from 'utils/api'
import { URLS } from 'components/shop-reception/mobile/constants'
import { useNavigate } from 'react-router-dom'
import { ReturoReportPayload } from 'components/shop-reception/mobile/interfaces'
import { getShopReceptionShops } from 'components/Layout/api'

const AddReport = () => {
  const [status, setStatus] = useState(null)

  const { showNotification } = useNotification()

  const navigate = useNavigate()

  const initialValues = useMemo(() => getInitialValues(), [])

  const validationSchema = useMemo(() => getValidationSchema(), [])

  const { data: shops } = getShopReceptionShops(showNotification, true)

  const saveReport = async (values: ReturoReportPayload) =>
    await makeCorePostRequest('/shop-reception-mobile/returo/notices', values)

  const { mutate } = useMutation(saveReport, {
    onSuccess: data => {
      const noticeId = data.id
      navigate(
        `${URLS.AUTH_RETURO_ADD_REPORT_SELECT_SEALS}?noticeId=${noticeId}&cmrNumber=${formik.values.cmrNumber}&truckNumber=${formik.values.truckNumber}&driverName=${formik.values.driverName}&providerName=${formik.values.providerName}&noticeStatus=${status}`
      )
    },
    onError: res => {
      showNotification({
        message: `A aparut o eroare la salvarea datelor despre procesul verbal. ${formatErrorMessage(
          res
        )}`,
        type: 'error'
      })
    }
  })

  const formik = useFormik({
    enableReinitialize: true,
    validateOnChange: false,
    initialValues: initialValues,
    validationSchema: validationSchema,
    onSubmit: async (values: ReturoReportPayload) => {
      if (
        !validateScanCode(showNotification, formik.values.cmrNumber, '', 'Cod invalid pentru CRM.')
      )
        return
      mutate(toReportPayload(status, values))
    }
  })

  const isSubmitButtonDisabled = useMemo(
    () =>
      !formik.values.cmrNumber ||
      !formik.values.truckNumber ||
      !formik.values.driverName ||
      !formik.values.providerName ||
      formik.isSubmitting,
    [formik.values]
  )

  const idReturo = useMemo(() => getReturoId(shops), [shops])

  return (
    <Container maxWidth="xs" style={{ marginTop: '20px' }}>
      <Grid container spacing={4}>
        <Grid item xs={12}>
          <TitleHeader title={`ID Returo: ${idReturo}`} />
        </Grid>
        <Grid item xs={12}>
          <Input
            type="text"
            name="cmrNumber"
            label="Număr CMR"
            fullWidth
            variant="outlined"
            value={formik.values.cmrNumber}
            onChange={event => formik.setFieldValue('cmrNumber', event.currentTarget.value)}
            error={!!formik.errors.cmrNumber}
            helperText={formik.errors.cmrNumber as string}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            type="text"
            name="truckNumber"
            label="Număr camion"
            fullWidth
            variant="outlined"
            value={formik.values.truckNumber}
            onChange={event => formik.setFieldValue('truckNumber', event.currentTarget.value)}
            error={!!formik.errors.truckNumber}
            helperText={formik.errors.truckNumber as string}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            type="text"
            name="driverName"
            label="Şofer"
            fullWidth
            variant="outlined"
            value={formik.values.driverName}
            onChange={event => formik.setFieldValue('driverName', event.currentTarget.value)}
            error={!!formik.errors.driverName}
            helperText={formik.errors.driverName as string}
            required
          />
        </Grid>
        <Grid item xs={12}>
          <Input
            type="text"
            name="providerName"
            label="Firma colectoare"
            fullWidth
            variant="outlined"
            value={formik.values.providerName}
            onChange={event => formik.setFieldValue('providerName', event.currentTarget.value)}
            error={!!formik.errors.providerName}
            helperText={formik.errors.providerName as string}
            required
          />
        </Grid>
        <Grid xs={12} item>
          <Button
            type="submit"
            variant="contained"
            label="Salvează PV"
            style={{ width: '100%' }}
            onClick={() => {
              setStatus('IN_PROGRESS')
              formik.handleSubmit()
            }}
            disabled={isSubmitButtonDisabled}
          />
        </Grid>
        <Grid xs={12} item>
          <Button
            type="submit"
            variant="contained"
            label="Finalizează PV"
            style={{ width: '100%' }}
            onClick={() => {
              setStatus('PROCESSED')
              formik.handleSubmit()
            }}
            disabled={isSubmitButtonDisabled}
          />
        </Grid>
      </Grid>
    </Container>
  )
}

export default AddReport
